module.exports = __webpack_public_path__ + "img/btn1.c599241b.png";